/**
 * Utility functions for analytics packages.
 * These functions are used to check if the code is running on the client or server.
 */

/**
 * Check if the code is running on the client.
 */
export function isClient(): boolean {
  return typeof window !== "undefined";
}

/**
 * Check if the code is running on the server.
 */
export function isServer(): boolean {
  return typeof window === "undefined";
}
